import gsap from "gsap";
import { DrawSVGPlugin, ScrollTrigger, CustomEase } from "gsap/all";
import DefaultBlock from "/scripts/default/block";
import { watchPreferredMotion } from "/utils/helpers/watchPreferredMotion";

// Register Plugins
gsap.registerPlugin(DrawSVGPlugin, ScrollTrigger, CustomEase);

export default class ScrollSmoothEffortless extends DefaultBlock {
	// Define variables
	init() {
		const selector = gsap.utils.selector(this.block);

		const DOM = {
			wrap: selector(".scroll-smooth-effortless__worm"),
			ball: selector("#worm-ball"),
			path: selector("#worm-path path"),
		};
		this.DOM = DOM;

		this.defaults = {
			ease: "power2.out",
			duration: 0.4,
		};

		this.tl = this.createTimeline();
	}

	ball() {
		gsap.set(this.DOM.ball, {
			motionPath: {
				path: this.DOM.path[0],
				align: this.DOM.path[0],
				alignOrigin: [0.5, 0.5],
				start: 0.65,
			},
		});

		return gsap.to(
			this.DOM.ball,
			{
				motionPath: {
					path: this.DOM.path[0],
					align: this.DOM.path[0],
					alignOrigin: [0.5, 0.5],
					start: 0.65,
				},
				ease: "none",
				duration: 4,
			},
			0.2
		);
	}

	createTimeline() {
		const tl = gsap.timeline({
			id: "scroll-balls-2",
			defaults: this.defaults,
			scrollTrigger: {
				invalidateOnRefresh: true,
				scrub: 1,
				trigger: this.DOM.wrap,
				start: "top 90%",
				end: "bottom 30%",
			},
		});

		tl.set(this.DOM.wrap, { autoAlpha: 1 });

		const mm = gsap.matchMedia();

		watchPreferredMotion(() => {
			/* Animate */
			tl.add(this.ball());
		});

		return tl;
	}
}
